
export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/item-groups`,
        name: `${prefix}.item-groups.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.item-groups.index`,
                PageDescription: "Accounts master data: Item groups",
            },
        },
    },
];
